module.exports = __webpack_public_path__ + "img/icon-corporate2.158c7f2b.svg";